export default {
  namespaced: true,
  state: {
    importPop: false,
    setting: {}
  },
  getters: {
    importPop: state => state.importPop,
    setting: state => state.setting
  },
  mutations: {
    mutateImportPop(state, data) {
      state.importPop = data
    },
    MUTATE_SETTING(state, data) {
      state.setting = data
    }
  },
  actions: {
    setImportPop(context, data) {
      context.commit('mutateImportPop', data)
    }
  }
}
